import styled from "styled-components";
import {
  PRIMARY_COLOR,
  QUERY_IPHONE_6_7_8_PLUS,
  QUERY_IPHONE_6_7_8,
} from "@shared/constants";

export const StyledFooter = styled.footer`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 128px;
  background-color: ${PRIMARY_COLOR};
  position: relative;

  h2 {
    white-space: nowrap;
    color: #ffffff;
    font-size: 32px;
    margin-bottom: 84px;
  }

  .pins {
    display: flex;

    .pin {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 80px;
      height: 80px;
      background-color: #ffffff;
      border-radius: 50%;
      border: 3px solid ${PRIMARY_COLOR};
      transition: all 0.3s;

      svg {
        fill: ${PRIMARY_COLOR};
        transition: all 0.3s;
      }

      &:not(:last-child) {
        margin-right: 60px;
      }

      &:hover {
        border-color: #ffffff;
        background-color: ${PRIMARY_COLOR};

        svg {
          fill: #ffffff;
        }
      }
    }
  }

  .shuttle {
    position: absolute;
    top: -45px;
    cursor: pointer;
    transition: transform 0.4s cubic-bezier(0.34, 1.56, 0.64, 1);

    &:hover {
      transform: translateY(-8px);
    }
  }

  @media (max-width: ${QUERY_IPHONE_6_7_8_PLUS}px) {
    padding: 150px 0;

    h2 {
      font-size: 28px;
    }

    .pins {
      .pin {
        width: 60px;
        height: 60px;
      }
    }
  }

  @media (max-width: ${QUERY_IPHONE_6_7_8}px) {
    .pins {
      .pin {
        &:not(:last-child) {
          margin-right: 40px;
        }
      }
    }
  }
`;
